export default __webpack_public_path__ + "static/images/prenota-47e4d01fc4fbdbe4c932a03a78650cc8.jpg";